import styled, {
  css,
} from 'styled-components';
import { smallMediaQuery } from '../Grid';
import { primaryColor1 } from '../Utils';
import {
  XLegendContainer as BottomLegendContainerBase,
  XxisLabelContainer as XAxisLabelContainerBase,
  YAxisLabelContainer as YAxisLabelContainerBase,
  YLegendContainer as LeftLegendContainerBase,
} from './Grid';

const legendTextColor = primaryColor1;
const legendContainerStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${primaryColor1};
  font-size: 1.125rem;

  @media ${smallMediaQuery} {
    font-size: 0.75rem;
  }
`;
export const getLeftLegendContainer = (base: typeof LeftLegendContainerBase) => styled(base)`
  ${legendContainerStyle}
  writing-mode: vertical-lr;
  transform: rotate(180deg);
`;
export const getBottomLegendContainer = (base: typeof BottomLegendContainerBase) => styled(base)`
  ${legendContainerStyle}
`;
const LegendItemBase = styled.div`
  position: relative;

  --triangle-height: 14px;
  --triangle-half-base: 6px;
  --triangle-color: ${legendTextColor};

  &::after {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
  }
`;
export const LeftLegendItemPositive = styled(LegendItemBase)`
  &::after {
    border-left: var(--triangle-half-base) solid transparent;
    border-right: var(--triangle-half-base) solid transparent;
    border-top: var(--triangle-height) solid var(--triangle-color);
    top: 105%;
    left: 45%;
    transform: translateX(-50%);
  }
`;
export const LeftLegendItemNegative = styled(LegendItemBase)`
  margin-bottom: 60px;

  &::after {
    border-left: var(--triangle-half-base) solid transparent;
    border-right: var(--triangle-half-base) solid transparent;
    border-bottom: var(--triangle-height) solid var(--triangle-color);
    bottom: 105%;
    left: 45%;
    transform: translateX(-50%);
  }
`;
export const BottomLegendPositive = styled(LegendItemBase)`
  margin-left: 60px;

  &::after {
    border-top: var(--triangle-half-base) solid transparent;
    border-bottom: var(--triangle-half-base) solid transparent;
    border-left: var(--triangle-height) solid var(--triangle-color);
    left: 105%;
    top: 55%;
    transform: translateY(-50%);
  }
`;
export const BottomLegendNegative = styled(LegendItemBase)`
  &::after {
    border-top: var(--triangle-half-base) solid transparent;
    border-bottom: var(--triangle-half-base) solid transparent;
    border-right: var(--triangle-height) solid var(--triangle-color);
    right: 105%;
    top: 55%;
    transform: translateY(-50%);
  }
`;
const axisLabelStyle = css`
  display: flex;
  justify-content: center;
  color: #666;
`;
export const getYAxisLabelContainer = (base: typeof YAxisLabelContainerBase) => styled(base)`
  ${axisLabelStyle}
  align-items: flex-end;
  writing-mode: vertical-lr;
  transform: rotate(180deg);

  @media ${smallMediaQuery} {
    font-size: 0.75rem;
  }
`;
export const getXAxisLabelContainer = (base: typeof XAxisLabelContainerBase) => styled(base)`
  ${axisLabelStyle}
  align-items: center;

  @media ${smallMediaQuery} {
    font-size: 0.75rem;
  }
`;
